const version = "2.7.5";

export { version };
//# sourceMappingURL=version.mjs.map
